import React from 'react';
import bem from 'utils/bem';
import { PodcastIcon, TelegramIcon, YoutubeIcon } from '../index';

import './index.sass';

const { cnBlock, el } = bem('social-icons');
const SocialIcons = ({ className, mod, ...rest }) => {
    return (
        <div className={ cnBlock(className) }>
            <TelegramIcon { ...rest } className={el('icon', 'telegram')} mod={ mod }/>
            <YoutubeIcon { ...rest } className={el('icon', 'youtube')} mod={ mod }/>
            <PodcastIcon { ...rest } className={el('icon', 'podcast')} mod={ mod }/>
        </div>
    );
}

export default SocialIcons;
